export const ManageScroll = (history, scrollSearch) => {
  var pathName = document.location.pathname + document.location.search;
  if (
    history.action === "PUSH" &&
    sessionStorage["scrollPosition_" + pathName]
  ) {
    sessionStorage.setItem("scrollPosition_" + pathName, 0);
  }
  if (
    history.action === "POP" &&
    (scrollSearch || scrollSearch == null) &&
    sessionStorage["scrollPosition_" + pathName]
  ) {
    var scroll = sessionStorage.getItem("scrollPosition_" + pathName);
    window.scrollTo({ top: scroll, behavior: "smooth" });
  }
};
